exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload_content_8eed35a{display:flex;align-items:flex-start}", ""]);

// exports
exports.locals = {
	"upload_content": "upload_content_8eed35a"
};